var _circle, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrashIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#FAFAFA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 27L22 24",
    stroke: "#11142D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 27L26 24",
    stroke: "#11142D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 19H33V19C32.0681 19 31.6022 19 31.2346 19.1522C30.7446 19.3552 30.3552 19.7446 30.1522 20.2346C30 20.6022 30 21.0681 30 22V28C30 29.8856 30 30.8284 29.4142 31.4142C28.8284 32 27.8856 32 26 32H22C20.1144 32 19.1716 32 18.5858 31.4142C18 30.8284 18 29.8856 18 28V22C18 21.0681 18 20.6022 17.8478 20.2346C17.6448 19.7446 17.2554 19.3552 16.7654 19.1522C16.3978 19 15.9319 19 15 19V19Z",
    stroke: "#11142D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0681 15.3706C22.1821 15.2643 22.4332 15.1703 22.7825 15.1033C23.1318 15.0363 23.5597 15 24 15C24.4403 15 24.8682 15.0363 25.2175 15.1033C25.5668 15.1703 25.8179 15.2643 25.9319 15.3706",
    stroke: "#11142D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIcon);
export default __webpack_public_path__ + "static/media/trash_icon.272f5370084ca97718cb113fa1fa9101.svg";
export { ForwardRef as ReactComponent };